<script lang="ts" setup>
const { LocalConfigurationStore } = stores()

const heading = computed(() => LocalConfigurationStore.value?.siteInfo?.productSectionTitle)

const productsInfo = computed(() =>
  LocalConfigurationStore.value?.products?.filter((p) => p.enabled)
)
</script>

<template>
  <div class="flex flex-col gap-1">
    <TitleComponent
      v-if="heading"
      :text="heading.title"
      :tagline="heading?.subTitle"
    />

    <GridComponent
      :cols="4"
      gap="sm"
    >
      <template
        v-for="product in productsInfo?.sort(
          (a, b) => (a?.priority ?? 1000) - (b?.priority ?? 1000)
        )"
        :key="product.code"
      >
        <div>
          <ContentProductThumbnail :product="product" />
        </div>
      </template>
    </GridComponent>
  </div>
</template>
